'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductInfo } from 'product/services/productInfo/client/useProductInfo'
import type { Product } from 'product/types/Product'

export const useGetProductInfo = (
	productId: string
): {
	productInfo: Product | undefined
	error: Error
	isLoading: boolean
} => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const { data, isLoading, error } = useProductInfo({
		productId,
		country: countryISO,
		language: languageISO,
		enabled: !!productId,
	})

	return {
		error,
		isLoading,
		productInfo: data,
	}
}
